import vehicle from './vehicle' // 车辆
import finance from './finance' // 财务
import workbench from './workbench' // 数据看板
import purchase from './purchase' // 采购
import underLease from './underLease' // 租赁中
import group from './group' // 集团
import driver from './driver' // 司机
import waitForRent from './waitForRent' // 待租
import returnLease from './returnLease' // 退租
import logs from './logs' // 日志

const domainRouter = [
  finance,
  vehicle,
  workbench,
  purchase,
  underLease,
  group,
  driver,
  waitForRent,
  returnLease,
  logs,
]

export default domainRouter
